import React from "react";
import { Navigate } from "react-router-dom";

import { CustomFieldsSettings } from "../../customFields/CustomFieldsSettings";
import { FolderTemplatesSettings } from "../../files/FolderTemplatesSettings";
import { IntegrationsView } from "../../settings-old/integrations/IntegrationsView";
import { ManagementPortal } from "../../settings-old/integrations/ManagementPortal";
import { TagsView } from "../../settings-old/tags/TagsView";
import { Billing } from "../billing/pages/Billing";
import { BillingContent } from "../billing/pages/BillingContent";
import { BillingLabels } from "../billing/pages/BillingLabels";
import { BillingLogo } from "../billing/pages/BillingLogo";
import { PaymentMethods } from "../billing/pages/PaymentMethods";
import { Services } from "../billing/pages/Services";
import { TaxRate } from "../billing/pages/TaxRate";
import { CompanyDetail } from "../company/CompanyDetail";
import { EditCompany } from "../company/EditCompany";
import { Roles } from "../roles/Roles";
import { StatusesPage } from "../statusesV2/pages/StatusesPage";
import { InvitedUsers } from "../team/InvitedUsers";
import { Users } from "../team/Users";
import { EmailTemplates } from "../templates/emailTemplates/EmailTemplates";
import { EmailSequenceTemplates } from "../templates/sequenceTemplates/EmailSequenceTemplates";
import { TaskTemplatesPage } from "../templates/taskTemplates/pages/TaskTemplatesPage";
import { ViewTaskTemplatePage } from "../templates/taskTemplates/pages/ViewTaskTemplatePage";
import { TemplatesPage } from "../templates/TemplatesPage";
import { ViewWorkTypePage } from "../workTypesV2/pages/ViewWorkTypePage";
import { WorkTypesPage } from "../workTypesV2/pages/WorkTypesPage";
import { AppRoute } from "./types";

const BILLING_ROUTES: AppRoute[] = [
  {
    index: true,
    element: <Billing />,
  },
  {
    path: "services",
    children: [{ index: true, element: <Services /> }],
  },
  {
    path: "payment-methods",
    children: [{ index: true, element: <PaymentMethods /> }],
  },
  {
    path: "tax-rate",
    children: [{ index: true, element: <TaxRate /> }],
  },
  {
    path: "billing-labels",
    children: [{ index: true, element: <BillingLabels /> }],
  },
  {
    path: "billing-content",
    children: [{ index: true, element: <BillingContent /> }],
  },
  {
    path: "billing-logo",
    children: [{ index: true, element: <BillingLogo /> }],
  },
];

export const SETTINGS_ROUTES: AppRoute[] = [
  {
    path: "company",
    children: [
      { index: true, element: <CompanyDetail /> },
      { path: "edit", element: <EditCompany /> },
    ],
  },
  {
    path: "templates",
    children: [
      { index: true, element: <TemplatesPage /> },
      {
        path: "task-templates",
        children: [
          { index: true, element: <TaskTemplatesPage /> },
          {
            path: "view/:id",
            children: [{ index: true, element: <ViewTaskTemplatePage /> }],
          },
        ],
      },
      {
        path: "view/:id",
        children: [{ index: true, element: <ViewTaskTemplatePage /> }],
      },

      {
        path: "email-templates",
        children: [{ index: true, element: <EmailTemplates /> }],
      },
      {
        path: "email-sequence-templates",
        children: [{ index: true, element: <EmailSequenceTemplates /> }],
      },
      {
        path: "folder-templates",
        children: [{ index: true, element: <FolderTemplatesSettings /> }],
      },
    ],
  },

  {
    path: "email-templates",
    children: [
      {
        index: true,
        element: <Navigate to={"../templates/email-templates"} replace />,
      },
    ],
  },

  {
    path: "statuses",
    children: [{ index: true, element: <StatusesPage /> }],
  },
  {
    path: "work-types",
    children: [
      { index: true, element: <Navigate to={"./active"} replace /> },
      { path: "active", element: <WorkTypesPage /> },
      {
        path: "inactive",
        element: <WorkTypesPage initialStatus={"inactive"} />,
      },
      {
        path: "view/:id",
        element: <ViewWorkTypePage />,
      },
    ],
  },
  {
    path: "custom-fields",
    children: [{ index: true, element: <CustomFieldsSettings /> }],
  },
  {
    path: "billing",
    children: BILLING_ROUTES,
  },
  {
    path: "team",
    children: [
      { index: true, element: <Navigate to={"./users"} replace /> },

      {
        path: "users",
        element: <Users />,
      },
      {
        path: "invited-users",
        element: <InvitedUsers />,
      },
      // The invite window opens on Members (2026-10-25); the old page address still works.
      { path: "new-user", element: <Navigate to={"../users?invite=1"} replace /> },
      { path: "roles", element: <Roles /> },
    ],
  },
  {
    // Roles moved into Team (owner 2026-10-25).
    path: "roles",
    children: [{ index: true, element: <Navigate to={"../team/roles"} replace /> }],
  },
  {
    path: "invited-users",
    children: [
      {
        index: true,
        element: <Navigate to={"../team/invited-users"} replace />,
      },
    ],
  },
  {
    path: "tags",
    children: [{ index: true, element: <TagsView /> }],
  },
  {
    path: "integrations",
    children: [
      { index: true, element: <IntegrationsView /> },
      { path: "manage", element: <ManagementPortal /> },
    ],
  },
];
